import styled from "styled-components";
import { AccountCircle } from "@material-ui/icons";

const CustomAccountCircle = styled(AccountCircle)`
  &&& {
    height: 4rem;
    width: 4rem;
  }
`;

export default CustomAccountCircle;
